export default "__VITE_ASSET__DMXEx1mv__"